export const TestSiteKey = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
export const ProdSiteKey = "6Lf9Di8bAAAAAKZt1Gi-sfVn7-4BOUDSAwiMyBE7";
